import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function ResidencyIndonesia() {

    return (
        <main className='main'>
            <SEO
                title="Indonesia Residency | Investor KITAS & Visa Options "
                description="Get residency in Indonesia through Investor KITAS, PT PMA, retirement, or spouse visas. Legal pathways for long-term stay and business. "
                keywords="Indonesia residency, Investor KITAS Indonesia, Indonesia visa options, PT PMA residency, Indonesia work permit, retirement visa Indonesia, spouse visa Indonesia, foreign residency Indonesia "
                url="/residency-indonesia"
            />
            <IntroSection
                title="Residency – Indonesia"
                subtitle="Legal Residency & Investor Pathways for Foreigners"
                description="Foreigners seeking to live in Indonesia must apply for a residency permit. The most popular route is through establishing a PT PMA (foreign-owned company), which grants eligibility for the Investor KITAS visa. Other pathways include retirement visas, spouse visas, and second-home permits."
                badges={[
                    "Investor KITAS",
                    "PT PMA Company Route",
                    "Long-Term Stay",
                    "Family Options"
                ]}
                buttonText="Request an Indonesia Residency Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/residency-passport/residency-indonesia-hero.png" )}
                imageAlt="Indonesia Residency & Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Residency in Indonesia?'
                        blocks={[
                            {
                                items: [
                                    { title: "Gateway to ASEAN", text: "Base in one of Asia’s fastest-growing economies." },
                                    { title: "Residency via Business", text: "Investor KITAS tied to PT PMA company ownership." },
                                    { title: "Lifestyle & Affordability", text: "Bali is a global hub for entrepreneurs & digital nomads." },
                                    { title: "Family Benefits", text: "Spouses and dependents can join under sponsored visas." },
                                    { title: "Flexibility", text: "Short-term, long-term, and second-home visas available." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency Options in Indonesia"
                        blocks={[
                            {
                                title: "1. Investor KITAS (through PT PMA)",
                                items: [
                                    { text: "Requires establishment of a PT PMA company." },
                                    { text: "Investors/shareholders receive a 1–2 year renewable residency permit." },
                                    { text: "Eligible for multiple-entry and re-entry rights." },
                                    { text: "Grants ability to live and legally work in Indonesia." }
                                ]
                            },
                            {
                                title: "2. Business & Work KITAS",
                                items: [
                                    { text: "For foreign professionals employed by Indonesian companies." },
                                    { text: "Linked to employment contracts." }
                                ]
                            },
                            {
                                title: "3. Retirement Visa",
                                items: [
                                    { text: "Available for foreigners aged 55+." },
                                    { text: "Must rent local property and have pension income." },
                                    { text: "Grants renewable stay permits." }
                                ]
                            },
                            {
                                title: "4. Second-Home Visa",
                                items: [
                                    { text: "Long-term visa for high-net-worth individuals." },
                                    { text: "Requires proof of funds deposited in Indonesian banks." }
                                ]
                            },
                            {
                                title: "5. Spouse/Family Visa",
                                items: [
                                    { text: "Available for foreigners married to Indonesian citizens." },
                                    { text: "Pathway to permanent residency." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='Key Features of Residency in Indonesia'
                        blocks={[
                            {
                                items: [
                                    { title: "Investor KITAS", text: "Valid for 1–2 years, renewable." },
                                    { title: "Residency Linked to Company", text: "PMA ownership enables legal residency and work rights." },
                                    { title: "Multiple-Entry Rights", text: "Access to local ID card (KITAS holder)." },
                                    { title: "Healthcare & Education", text: "Access to local healthcare, education, and services." },
                                    { title: "Family Residency", text: "Spouse and children can also obtain residency." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Benefits of Indonesia Residency"
                        services={[
                            { title: "Live in Indonesia", text: "Bali, Jakarta, and beyond with legal residency." },
                            { title: "Investor-Friendly", text: "PMA route designed for foreign entrepreneurs." },
                            { title: "Bank Account Access", text: "Eligible for local corporate and personal accounts." },
                            { title: "Long-Term Stay", text: "Renewable permits for ongoing presence." },
                            { title: "Second-Home Options", text: "Available for high-net-worth individuals." }
                        ]}
                    />

                    <LocationTimeline
                        title="Application Process"
                        item={[
                            "Consultation & eligibility check.",
                            "Company setup (PT PMA) if pursuing Investor KITAS.",
                            "Document submission: passport, proof of funds, investment plan.",
                            "Application with Indonesian immigration authorities.",
                            "KITAS approval and biometric registration.",
                            "Residency card issuance (KITAS/Second-Home Visa)."
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "4–8 weeks depending on visa type",
                            },
                            {
                                name: "Costs",
                                description: "Investor KITAS via PT PMA: from USD 8,000+ (including company setup),\nRetirement Visa: from USD 3,000+,\nSecond-Home Visa: from USD 5,000+",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in PT PMA incorporation + Investor KITAS applications" },
                                { text: "Assistance with residency, tax, and relocation" },
                                { text: "Network in Bali & Jakarta for legal and immigration support" },
                                { text: "Comparative insights: Indonesia vs Malaysia vs Thailand vs UAE" },
                                { text: "End-to-end service: company, visa, banking, and compliance" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Want to live and invest in Indonesia?"
                        description="The Investor KITAS and other residency programs provide long-term, legal stay options for entrepreneurs, families, and retirees."
                        buttonText="Book an Indonesia Residency Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I live in Indonesia long-term as a foreigner?",
        content: [
            { type: "answer", text: "Yes — via Investor KITAS, retirement, or second-home visa." },
        ],
    },
    {
        question: "Do I need to set up a company for residency?",
        content: [
            { type: "answer", text: "Yes — if applying for the Investor KITAS route." },
        ],
    },
    {
        question: "How long is the Investor KITAS valid?",
        content: [
            { type: "answer", text: "1–2 years, renewable." },
        ],
    },
    {
        question: "Can I bring my family?",
        content: [
            { type: "answer", text: "Yes — spouse and children can obtain dependent visas." },
        ],
    },
    {
        question: "Does residency lead to citizenship?",
        content: [
            { type: "answer", text: "Not directly — citizenship in Indonesia is very restrictive." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory helped us set up a PT PMA in Bali and secure Investor KITAS visas. Now we legally live and run our business here.",
        author: "Oliver H.",
        role: "Entrepreneur"
    },
    {
        quote: "I retired in Bali using the Retirement Visa program. Offshore Advisory made the transition smooth and worry-free.",
        author: "Maria F.",
        role: "Retiree"
    }
];
